import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import { PreFlightStatus } from './enumerations';
import {
  ApprovePreFlightParams,
  ApprovePreFlightProps,
  DeleteReviewerDocumentProps,
  GetAllPreFlightRequestsProps,
  GetPreFlightCompaniesProps,
  GetPreFlightRequestProps,
  RejectPreFlightParams,
  RejectPreFlightProps,
  UpdatePreFlightWorkOrderProps,
  UpdateWorkOrderParams,
  UploadReviewerDocumentProps,
} from './types';

export const getPreFlightCompanies =
  (): Promise<GetPreFlightCompaniesProps> => {
    const requestOptions = {
      method: 'GET',
      headers: myHeadersWithTokenContentType(),
    };
    const baseUrl = handleUrl();
    return fetch(
      `${baseUrl}/api/V1/preflight-requests/companies`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => JSON.parse(result))
      .catch((error) => new Error(error));
  };

export const getAllPreFlightRequests = (
  page: number,
  size: number,
  companyId?: number,
  status?: PreFlightStatus,
  search?: string
): Promise<GetAllPreFlightRequestsProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();

  const params: Record<string, string> = {
    page: String(page),
    size: String(size),
  };
  if (status) params.status = status;
  if (companyId) params.company_id = String(companyId);
  if (search) params.search = search;

  const queryString = new URLSearchParams(params).toString();

  return fetch(
    `${baseUrl}/api/V1/preflight-requests?${queryString}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getPreFlightRequest = (
  id: number
): Promise<GetPreFlightRequestProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/preflight-requests/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const updatePreFlightWorkOrder = (
  id: number,
  data: UpdateWorkOrderParams
): Promise<UpdatePreFlightWorkOrderProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/preflight-requests/${id}/work-order`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const approvePreFlightRequest = (
  id: number,
  data?: ApprovePreFlightParams
): Promise<ApprovePreFlightProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data ?? {}),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/preflight-requests/${id}/approve`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const rejectPreFlightRequest = (
  id: number,
  data: RejectPreFlightParams
): Promise<RejectPreFlightProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/preflight-requests/${id}/reject`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const uploadPreFlightDocument = (
  id: number,
  formData: FormData
): Promise<UploadReviewerDocumentProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: formData,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/preflight-requests/${id}/documents`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const deletePreFlightDocument = (
  id: number,
  s3Key: string
): Promise<DeleteReviewerDocumentProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  const queryString = new URLSearchParams({ s3_key: s3Key }).toString();
  return fetch(
    `${baseUrl}/api/V1/preflight-requests/${id}/documents?${queryString}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
